import React from 'react';
import {
  Button,
  Confirm,
  Dropdown,
  Header,
  Form,
  Icon,
  Tab,
} from 'semantic-ui-react';
import Details from './event/details';
import Images from './event/images';
import { inlineStyle } from '../../styles/custom';
import { languages } from '../../constants';
import PermissionsManager from '../PermissionsManager';
import VideoGalleryBlock from './pageBuilder/blocks/video_gallery_block';
import ImageGalleryBlock from './pageBuilder/blocks/image_gallery_block';

const renderPanes = (status, obj, onChange) => {
  let panes = languages.map((language) => {
    const attrs = { status, obj, language, onChange };
    return {
      menuItem: language.label,
      render: () => (
        <Tab.Pane key={language.code} attached={false}>
          <Details {...attrs} />
        </Tab.Pane>
      ),
    };
  });

  panes.push({
    menuItem: 'Gestion des images',
    render: () => (
      <Tab.Pane attached={false}>
        <Images obj={obj} onChange={onChange} />
      </Tab.Pane>
    ),
  });

  return panes;
};

const renderCategories = (categories) => {
  if (categories === undefined) return null;

  let _categories = [{ value: null, text: '--' }];
  categories.forEach((category) => {
    _categories.push({ value: category.id, text: category.details[0].label });
  });
  return _categories;
};

const EventForm = ({
  obj,
  status,
  categories,
  onChange,
  onSubmit,
  onDelete,
  videoGalleryRef,
  imageGalleryRef,
}) => {
  let event_date;
  if (obj.event_date === null) {
    const d = new Date();
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    event_date = `${month}-${day}-${year}`;
  } else {
    event_date = obj.event_date.replace(/\//g, '-');
  }

  const videoBlockIndex = obj.blocks.findIndex(
    (block) => block.type === 'video_gallery_block',
  );
  const imageBlockIndex = obj.blocks.findIndex(
    (block) => block.type === 'image_gallery_block',
  );

  return (
    <Form>
      <Header>Événement{status.isNew ? ' : Création' : ' : Édition'}</Header>
      <Form.Field>
        <label>Catégorie</label>
        {categories.loading && (!obj.category || !obj.category.id) ? (
          <div>Chargement des catégories</div>
        ) : (
          <Dropdown
            placeholder="Sélectionnez une catégorie"
            fluid
            selection
            closeOnChange
            id="category_id"
            value={obj.category_id}
            options={renderCategories(categories.getCategories)}
            onChange={(e, data) => onChange(e, data, 'dropdown')}
          />
        )}
      </Form.Field>
      <Form.Field
        id="event_date"
        label="Date (tri chronologique)"
        control="input"
        type="date"
        onChange={(e, data) => {
          onChange(e, data);
        }}
        value={event_date}
      />
      <Form.Field
        id="promote_homepage"
        label="A afficher sur la homepage"
        control="input"
        type="checkbox"
        onChange={(e, data) => {
          onChange(e, data);
        }}
        defaultChecked={obj.promote_homepage}
      />
      <Tab
        menu={{ pointing: true }}
        panes={renderPanes(status, obj, onChange)}
      />
      <VideoGalleryBlock
        obj={videoBlockIndex !== -1 ? obj.blocks[videoBlockIndex] : null}
        ref={videoGalleryRef}
      />
      <ImageGalleryBlock
        obj={imageBlockIndex !== -1 ? obj.blocks[imageBlockIndex] : null}
        ref={imageGalleryRef}
      />
      <br />
      <br />
      <Form.Field>
        {status.loading ? (
          <Button type="submit" floated="left" color="red" loading>
            {' '}
            Chargement...
          </Button>
        ) : (
          <PermissionsManager hasPermissions={['create_event', 'update_event']}>
            <Button
              type="submit"
              floated="left"
              color="olive"
              onClick={onSubmit}
            >
              <Icon name="save" /> Sauvegarder
            </Button>
          </PermissionsManager>
        )}
        {!status.isNew ? (
          <div>
            <PermissionsManager hasPermissions={['delete_event']}>
              <Button
                type="submit"
                color="red"
                floated="right"
                onClick={(event, data) => {
                  onDelete(event, { confirm: true });
                }}
              >
                <Icon name="delete" /> Suppression
              </Button>
            </PermissionsManager>
          </div>
        ) : null}
      </Form.Field>
      <Confirm
        content="Êtes-vous sûr(e) de vouloir supprimer cet événement ? Cette action est définitive."
        open={status.deletion.confirm}
        onCancel={(event, data) => {
          onDelete(event, { confirm: null });
        }}
        onConfirm={(event, data) => {
          onDelete(event, { confirm: false });
        }}
        style={inlineStyle.modal}
        cancelButton="Annuler"
        confirmButton="Ok"
      />
    </Form>
  );
};

export default EventForm;



// WEBPACK FOOTER //
// ./src/components/form/Event.js